"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyStatisticsItem = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const classes_1 = require("../../../server/classes");
const server_1 = require("../../../server");
const DSSL007_List_1 = require("../../DSS/DSSL007/DSSL007_List");
const classes_2 = require("../../base/classes");
const ui_1 = require("../ui");
exports.AcademyStatisticsItem = react_1.default.memo(({ id, class_id }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { data: memberData, refetch: refetchMember } = (0, server_1.useMemberInfo)(id ? { id } : undefined);
    const member = memberData?.items?.[0];
    const [className, setClassName] = react_1.default.useState('');
    (0, react_1.useEffect)(() => {
        if (id)
            refetchMember();
    }, [id]);
    (0, react_1.useEffect)(() => {
        if (!class_id)
            return;
        const loadClassData = async () => {
            const classData = await (0, classes_1.getClassesList)({ id: class_id });
            const { total_count, items } = classData.result;
            if (total_count > 0) {
                const found = items.find((i) => i.id === class_id);
                dispatch((0, classes_2.setClassesData)(found));
                setClassName(found?.title || '');
            }
            else {
                dispatch((0, classes_2.setClassesData)(undefined));
                setClassName('');
            }
        };
        loadClassData();
        return () => {
            dispatch((0, classes_2.setClassesData)(undefined));
        };
    }, [class_id]);
    return (react_1.default.createElement("div", { className: "admin-main", style: { gap: 48 } },
        react_1.default.createElement("div", { className: "admin-detail-info" },
            react_1.default.createElement("div", { className: "admin-title" },
                react_1.default.createElement("div", { className: "admin-title-left" },
                    react_1.default.createElement("p", null, t('academy.section.userInfo')))),
            react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20, width: '100%' } },
                react_1.default.createElement(ui_1.TextInput, { title: t('table.name'), defaultValue: member?.nickname || '', disabled: true, noShowButtonArea: true }),
                react_1.default.createElement(ui_1.TextInput, { title: t('table.id'), defaultValue: member?.identifier || '', disabled: true, noShowButtonArea: true }),
                react_1.default.createElement(ui_1.TextInput, { title: t('table.className'), defaultValue: className, disabled: true, noShowButtonArea: true }))),
        class_id && (react_1.default.createElement(DSSL007_List_1.DSSL007_List, { isAdmin: true, classId: class_id, selectUserId: id, reportTitle: t('academy.section.classGradeReport') }))));
});
